import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import FormikProvider from '../../shared/forms/formikProvider.component';
import Modal from '../../shared/modals/modal.component';
import Form from '../../shared/forms/form.component';

import schema from './glJournalForm.schema';

import {
  fetchInitialDataForGlJournalsAddEditModal,
} from './store/actions';
import {
  isFetchingInitialDataForAddAndEditModalSelector,
  typeOptionsSelector,
  activityOptionsSelector,
  slAccountOptionsSelector,
  glAccountOptionsSelector,
  slTaxEntriesSelector,
  sharedSelectors,
} from './store/selectors';

import {
  GlJournalsPropTypes,
  GlJournalPropTypes,
  SlTaxEntriesPropTypes,
} from './propTypes';
import { OptionsPropType } from '../../shared/propTypes/common';
import { PeriodPropTypes } from '../shared/propTypes';
import { encodeCountryTaxType } from '../../utils/encodeDecodeCTT';

const ModalTitles = {
  ADD: 'Add GL Journal',
  EDIT: 'Edit GL Journal',
};

class AddEditModal extends PureComponent {
  static propTypes = {
    glJournals: GlJournalsPropTypes.isRequired,

    period: PeriodPropTypes.isRequired,
    entityToEdit: GlJournalPropTypes,
    typeOptions: OptionsPropType,
    activityOptions: OptionsPropType,
    slAccountOptions: OptionsPropType,
    glAccountOptions: OptionsPropType,
    slTaxEntries: SlTaxEntriesPropTypes.isRequired,

    hideModal: PropTypes.func.isRequired,

    fetchInitialData: PropTypes.func.isRequired,
    isFetchingInitialData: PropTypes.bool.isRequired,
    saveEntity: PropTypes.func.isRequired,
    isSavingInProgress: PropTypes.bool.isRequired,
    isVisible: PropTypes.bool,
    openForEdit: PropTypes.bool,
  };

  componentDidMount() {
    const { period, fetchInitialData } = this.props;

    fetchInitialData(period);
  }

  componentDidUpdate(prevProps) {
    const { period, fetchInitialData } = this.props;
    if (prevProps.period !== period) {
      fetchInitialData(period);
    }
  }

  save = (formData, { setSubmitting, resetForm }) => {
    const { period, saveEntity, openForEdit } = this.props;

    saveEntity({
      ...formData,
      periodName: period.name,
    }, openForEdit, {
      params: {
        periodName: period.name,
        countryTaxType: formData.countryTaxType,
        type: formData.type,
        activity: formData.activity,
        slAccount: formData.slAccount,
      },
      callback: resetForm,
    });
    setSubmitting(false);
  };

  renderModal = ({ formik, schema }) => {
    const {
      openForEdit,
      typeOptions,
      activityOptions,
      slAccountOptions,
      glAccountOptions,
      hideModal,
      isVisible,
      isSavingInProgress,
      isFetchingInitialData,
    } = this.props;

    const reset = () => {
      hideModal();
      formik.resetForm();
    };

    return (
      <Modal
        className="add-edit-gl-journal-modal"
        title={openForEdit ? ModalTitles.EDIT : ModalTitles.ADD}
        closeAction={reset} // eslint-disable-line react/jsx-no-bind
        dismissText="Cancel"
        dismissAction={reset} // eslint-disable-line react/jsx-no-bind
        submitText="Save"
        submitAction={formik.handleSubmit}
        isSubmitting={formik.isSubmitting || isSavingInProgress}
        isVisible={isVisible}
        isLoading={isFetchingInitialData}
      >
        <Form
          formik={formik}
          schema={schema}
          openForEdit={openForEdit}
          formContext={{
            typeOptions,
            activityOptions,
            slAccountOptions,
            glAccountOptions,
          }}
        />
      </Modal>
    );
  };

  render() {
    const { entityToEdit, glJournals, slTaxEntries, openForEdit } = this.props;

    const formattedEntity = entityToEdit
      ? {
        ...entityToEdit,
        countryTaxType: encodeCountryTaxType(entityToEdit.countryCode, entityToEdit.countryTaxType),
      }
      : null;

    return (
      <FormikProvider
        schema={schema}
        entityToEdit={formattedEntity}
        onSubmit={this.save}
        render={this.renderModal}
        validationContext={{
          entities: glJournals,
          openForEdit,
          slTaxEntries,
        }}
      />
    );
  }
}

const mapStateToProps = state => ({
  glJournals: sharedSelectors.entitiesSelector(state),
  typeOptions: typeOptionsSelector(state),
  activityOptions: activityOptionsSelector(state),
  slAccountOptions: slAccountOptionsSelector(state),
  glAccountOptions: glAccountOptionsSelector(state),
  slTaxEntries: slTaxEntriesSelector(state),
  isSavingInProgress: sharedSelectors.savingEntitySelector(state),
  isFetchingInitialData: isFetchingInitialDataForAddAndEditModalSelector(state),
});

export default connect(
  mapStateToProps,
  {
    fetchInitialData: fetchInitialDataForGlJournalsAddEditModal,
  }
)(AddEditModal);
